import React from 'react';
import { FormattedMessage } from 'react-intl';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import { ButtonWithLoader } from '../../../button-with-loader/button-with-loader';

import '../deposit-new.scss';

export const BonusStepButton = ({
  wrapperClassName,
  isModal,
  isInProgress,
  isBonusSelected,
  onSubmit,
}) => (
  <div className={classNames('bonus-step-button-loader-wrapper', wrapperClassName, { 'is-in-modal': isModal })}>
    <div className="button-loader-with-background">
      <ButtonWithLoader
        isLoading={isInProgress}
        className="d-flex align-items-center justify-content-center w-100 mt-1_5"
        color={isBonusSelected ? 'primary' : 'white'}
        type="submit"
        outline={!isBonusSelected}
        onClick={onSubmit}
      >
        <FormattedMessage id={isBonusSelected ? 'deposit' : 'continue.without.bonus'} />
      </ButtonWithLoader>
    </div>
  </div>
);

BonusStepButton.propTypes = {
  wrapperClassName: PropTypes.string.isRequired,
  isModal: PropTypes.bool.isRequired,
  isInProgress: PropTypes.bool.isRequired,
  isBonusSelected: PropTypes.bool.isRequired,
  onSubmit: PropTypes.func.isRequired,
};
